export default "__VITE_ASSET__OktiWjo2__$_?url__"